import React from 'react'
import './CreditWrapper.scss'

const CreditWrapper = ({children, title}) => {

    return (
        <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16">
            <div className="flex flex-col justify-center CreditWrapper">
                <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none  md:text-5xl lg:text-6xl dark:text-white">{title}</h1>
            </div>
            {children}
        </div>


    )
}

export default CreditWrapper